import { indexPage } from "./indexPage";
import { tinTucPage } from "./tinTucPage";
import { megastoryPage } from "./megastoryPage";
import { landingpagePage } from "./landingpagePage";
import { tongQuanPage } from "./tongQuanPage";
// import { chuongTrinhHocPage } from "./chuongTrinhHocPage";
import { moiTruongHocTapPage } from "./moiTruongHocTapPage";

export const routing = {
  indexPage,
  tinTucPage,
  tongQuanPage,
  megastoryPage,
  landingpagePage,
  // chuongTrinhHocPage,
  moiTruongHocTapPage
};
